<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择行项"
      width="1200px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="YiXinShipmentApplication/toDoPurchasePage"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="primary" @click="add()">新增</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="合同号">
            <el-input
                v-model.trim="filter.clientContractNos"
                style="width: 150px"
                clearable
                type="textarea"
                placeholder="多个精准搜索"/>
          </vm-search>
          <vm-search label="合同号">
            <el-input v-model.trim="filter.clientContractNo" style="width: 150px" clearable placeholder="单个模糊查询"/>
          </vm-search>
          <vm-search label="SAP订单号">
            <el-input
                v-model.trim="filter.salesOrderNos"
                style="width: 150px"
                clearable
                type="textarea"
                placeholder="多个精准搜索"/>
          </vm-search>
          <vm-search label="SAP订单号">
            <el-input v-model.trim="filter.salesOrderNo" style="width: 150px" clearable placeholder="单个模糊查询"/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="customerContractNo"
          align="center"
          label="项目名称"
          min-width="340"
          show-overflow-tooltip/>
      <el-table-column
          prop="customerName"
          align="center"
          label="客户"
          min-width="200"
          show-overflow-tooltip/>
      <el-table-column
          prop="salesName"
          align="center"
          width="120"
          label="创建者"
          show-overflow-tooltip/>
      <el-table-column prop="billNo" align="center" width="100" label="SAP订单号"/>
      <el-table-column
          prop="clientContractNO"
          align="center"
          label="客户合同号"
          width="240"
          show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" width="90" label="计划交期"/>
      <el-table-column prop="totalAmount" align="center" width="90" label="总金额"/>
      <el-table-column prop="submitTime" align="center" width="135" label="提交时间"/>
      <el-table-column prop="status" align="center" width="100" label="状态"/>
      <el-table-column prop="deliveryStatusName" align="center" width="70" label="发货状态"/>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "ToDoPurchaseYiXinApplicationSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: "",
          clientContractNo:"",
          clientContractNos:"",
          salesOrderNo:"",
          salesOrderNos:"",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      select(selection) {
        this.selection = selection;

      },
      add() {
        if(this.selection) {
          this.$emit("select", this.selection);
          this.dialogVisible = false;
        }else {
          this.$message.error("请选择需要添加的行项！");
        }
        
      },
    },
  };
</script>